// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_BQQ","cls2":"search_work_card_redesign-cls2_E6D search_work_card_redesign-cls1_BQQ"};